module.exports = __webpack_public_path__ + "static/img/p3_img1.05d3538.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p3_img1.png
// module id = /LVI
// module chunks = 0